export function isIOSMobileBrowser(): boolean {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent;
  const platform = navigator.platform;
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  const isIPhoneIPadIPod = /iPad|iPhone|iPod/.test(ua);
  const isIPadOSDesktopMode = platform === "MacIntel" && maxTouchPoints > 1;

  return isIPhoneIPadIPod || isIPadOSDesktopMode;
}